import React from 'react';
import SpeakerIcon from '../ActivityDetail/diarization/SpeakerIcon';

// おすすめポイントを生成できなかった推薦結果の注記 (画面レイアウト_SCR-M-001.md DP-M-016。PM 確定 2026-10-04、Issue #1129)。
// AI ポイントには触れない: 実行した直後は消費しているが、開き直したときや前回の結果を再利用した
// 実行では、その場では消費していないため。「ポイント未消費」とも書かない (#868)
export const REASONS_NOT_GENERATED_MESSAGE =
    'この推薦結果では、おすすめポイントを生成できませんでした。'
    + 'マッチ度と並びは算出済みです。推薦 PDF のおすすめポイントの欄は空欄になります。';

/**
 * 推薦結果の全件でおすすめポイントを生成できなかったことを伝える注記 (DP-M-016、Issue #1129)。
 *
 * 出すかどうかは呼び出し側が決める (phase が results かつ応答の reasons_generated が false)。
 * 判定は BE が返す reasons_generated を使い、画面は要素を数え直さない。
 * 見た目は SCR-D-001 DP-D-009 と同じ Warning の帯 (白の背景・左の罫線・triangle-alert のアイコンと文)。
 * アイコンは lucide の triangle-alert の形をインラインの SVG で書いた既存の部品 (SpeakerIcon) を使う
 * (lucide-react は依存に入っていない。「⚠」の文字は色を決められないため使わない)。アイコンは
 * 読み上げから外し、文を読む。推薦結果の領域 (aria-live) の中に置くため role="alert" にしない
 * (開き直すたびに出る、エラーではない状態のため)。
 */
function ReasonsNotGeneratedNotice() {
    return (
        <p className="matching-reasons-not-generated-notice" data-testid="matching-reasons-not-generated">
            <SpeakerIcon name="triangle-alert" />
            <span>{REASONS_NOT_GENERATED_MESSAGE}</span>
        </p>
    );
}

export default ReasonsNotGeneratedNotice;
